import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  query: '',
  isSearching: false,
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearchQuery(state, action) {
      state.query = action.payload;
      state.isSearching = action.payload.length > 0;
    },
    resetSearchQuery(state) {
      state.query = '';
      state.isSearching = false;
    },
  },
});

export const { setSearchQuery, resetSearchQuery } = searchSlice.actions;
export default searchSlice.reducer;
